import { VImg } from 'vuetify/lib/components/VImg';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(_setup.CoreSwiper, {
    scopedSlots: _vm._u([
      {
        key: "slides",
        fn: function ({ slideAttrs }) {
          return _vm._l(_vm.doctorRates, function (doctorRate) {
            return _c(
              "div",
              _vm._b({ key: doctorRate.doctor.id }, "div", slideAttrs, false),
              [
                _c(
                  "div",
                  {
                    staticClass:
                      "d-flex flex-column gr-4 elevation-1 rounded-sm pa-4 mx-2",
                  },
                  [
                    _c("div", { staticClass: "d-flex gc-4" }, [
                      _c(
                        "a",
                        {
                          staticClass: "text-decoration-none",
                          attrs: {
                            href: `/${doctorRate.doctor.url}`,
                            target: "_blank",
                            rel: "noopener noreferrer",
                          },
                        },
                        [
                          _c(VImg, {
                            staticClass: "rounded-lg",
                            attrs: {
                              src: doctorRate.doctor.avatar,
                              "lazy-src":
                                "/static/_v1/pd/icons/ui-kit/photo/no-avatar.svg",
                              alt: _setup.t("Аватар", _setup.options),
                              width: "80",
                              height: "80",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "d-flex flex-column" }, [
                        _c(
                          "a",
                          {
                            staticClass:
                              "text-subtitle-1 text-decoration-none primary--text",
                            attrs: { href: `/${doctorRate.doctor.url}` },
                          },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(
                                  _setup.transDynamic(
                                    doctorRate.doctor,
                                    `fio,${_setup.languageIso},${_setup.needTranslate}`
                                  )
                                ) +
                                "\n            "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "span",
                          { staticClass: "text-body-1 text-info--text" },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(
                                  _setup.transDynamic(
                                    doctorRate.doctor,
                                    `meta,${_setup.languageIso},${_setup.needTranslate}`
                                  )
                                ) +
                                "\n            "
                            ),
                          ]
                        ),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "text-body-1 text--text" }, [
                      _vm._v(
                        "\n          " +
                          _vm._s(doctorRate.rateText) +
                          "\n        "
                      ),
                    ]),
                  ]
                ),
              ]
            )
          })
        },
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }